define("shared/utils/time-slot-utils", ["exports", "later/utils/time-format"], function (_exports, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.roundedHalfHourMow = _exports.getWdayInMins = _exports.getMow = _exports.getHourInMins = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/time-format"eaimeta@70e063a35619d71f
  const getHourInMins = value => {
    return _timeFormat.convert.hours(value).toMinutes();
  };
  _exports.getHourInMins = getHourInMins;
  const getWdayInMins = value => {
    return _timeFormat.convert.days(value).toMinutes();
  };
  _exports.getWdayInMins = getWdayInMins;
  const roundedHalfHourMow = timeSlot => {
    let newMinute = timeSlot.minute;
    if (timeSlot.minute < 15) {
      newMinute = 0;
    } else if (timeSlot.minute >= 15 && timeSlot.minute < 45) {
      newMinute = 30;
    } else if (timeSlot.minute >= 45) {
      newMinute = 60;
    }
    return newMinute + getHourInMins(timeSlot.hour) + getWdayInMins(timeSlot.wday);
  };
  _exports.roundedHalfHourMow = roundedHalfHourMow;
  const getMow = timeSlot => {
    return timeSlot.minute + getHourInMins(timeSlot.hour) + getWdayInMins(timeSlot.wday);
  };
  _exports.getMow = getMow;
});